import script from "./qxdj_order.vue?vue&type=script&setup=true&lang=js"
export * from "./qxdj_order.vue?vue&type=script&setup=true&lang=js"

import "./qxdj_order.vue?vue&type=style&index=0&id=67787aa1&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67787aa1"]])

export default __exports__